import './RedirectExecutor.scss';
import React from 'react';
import MessageDialog, { IMessageDialogProps } from '@srm/ui/message-dialog';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { IRedirectExecutorProps } from './IRedirectExecutorProps';

export const RedirectExecutorModal: React.FC<IRedirectExecutorProps> = (props: IRedirectExecutorProps) => {
    const { errorText, isBusy, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        submit: () => new DocumentExecutionService(props.docId).redirect(props.actionKey),
    });

    const messageBoxProp: IMessageDialogProps = {
        header: `${props.title}`,
        message: `${props.message}`,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        size: props.modalSize,
        loading: isBusy,
        onConfirm: okClick,
        onCancel: cancelClick,
    };

    return <MessageDialog {...messageBoxProp} errorText={errorText} />;
};
